
import React from 'react';
export const SwapLeft = props => (
  <svg viewBox="0 0 20 20" {...props}><path d="M2.6406503,11.9173152 L19.2310723,11.9173152 C19.6557393,11.9173152 20,12.2716113 20,12.7086576 C20,13.1457039 19.6557393,13.5 19.2310723,13.5 L0.770470992,13.5 C0.0834880204,13.5 -0.258696077,12.6434821 0.229609261,12.1461739 L5.54885399,6.72885877 C5.850706,6.42144154 6.33755745,6.42406316 6.63626714,6.73471432 C6.93497682,7.04536548 6.93242946,7.54640892 6.63057745,7.85382615 L2.6406503,11.9173152 Z" fillRule="evenodd" /></svg>
);
